const config = {
  env: "dev",
  apiBaseUrl: "https://libretodo-backend.renv.link/api",
};

export default config;
